


























import Vue, { PropType } from "vue"
import FilterDescription from "~/components/custom/search/FilterDescription.vue"
import { NormalOption } from "~/clStores/profileSearchParameterOption"

export default Vue.extend({
  components: {
    FilterDescription,
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      required: true,
    },
    options: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
  },
  methods: {
    isSelected(availableUptimeId: number): boolean {
      return this.value.includes(availableUptimeId)
    },
    handleInput(selectedAvailableUptimeIds: number[]) {
      this.$emit("input", selectedAvailableUptimeIds)
    },
    extractIdsInBetween(edgeId1: number, edgeId2: number) {
      const [diff, minVal] =
        edgeId1 < edgeId2
          ? [edgeId2 - edgeId1, edgeId1]
          : [edgeId1 - edgeId2, edgeId2]
      return [...new Array(diff + 1)].map((_, idx) => idx + minVal)
    },
    select(availableUptimeId: number) {
      // １つも選択されていない場合または複数選択されている場合は、今回選択されたものだけを選択した状態にする。
      if (this.value.length === 0 || this.value.length > 1) {
        this.handleInput([availableUptimeId])
        return
      }

      // 1つのみ選択された状態で、その１つを今回選択した場合は、未選択状態にする。
      if (this.value.length === 1 && this.value[0] === availableUptimeId) {
        this.handleInput([])
        return
      }

      // 1つのみ選択した場合で異なる選択肢を選んだ場合はその２つの間のものを全て選択した状態にする。
      this.handleInput(
        this.extractIdsInBetween(availableUptimeId, this.value[0])
      )
    },
  },
})
